import React from "react";

export function Search() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.1693 18.3367L18.5483 14.7157C19.2067 13.399 19.6456 11.8628 19.6456 10.3267C19.6456 5.16958 15.476 1 10.3189 1C5.1618 1 0.992218 5.16958 0.992218 10.3267C0.992218 15.4838 5.1618 19.6534 10.3189 19.6534C11.8551 19.6534 13.3912 19.2145 14.7079 18.5561L18.3289 22.1771C19.4261 23.2743 21.072 23.2743 22.1693 22.1771C23.1568 21.0798 23.1568 19.4339 22.1693 18.3367ZM10.3189 17.4589C6.36878 17.4589 3.18673 14.2768 3.18673 10.3267C3.18673 6.37656 6.36878 3.19451 10.3189 3.19451C14.269 3.19451 17.4511 6.37656 17.4511 10.3267C17.4511 14.2768 14.269 17.4589 10.3189 17.4589Z"
        fill="#3C4E64"
      />
    </svg>
  );
}
